export default "__VITE_ASSET__05cGn3ID__"